/**
 * Constructor method for creating instance of sidebar menu button which controls the initialization
 * and visibility of the sidebar menu and its children
 *
 * Instance properties
 * - domNode : reference to domNode
 * - sidebarNav : reference to the sidebarNav instance
 *
 * - pageContent : reference to the pageContent dom element
 * - background : reference to the background dom element
 * - footer : reference to the footer dom element
 *
 * @param {Node} domNode DomNode for the headerNavItem
 */

const SidebarNavBtn = function (domNode) {
  this.domNode = domNode;

  this.sidebarNav = false;
  this.pageContent = false;
  this.background = false;
  this.footer = false;
};

/*
 * Initializer for a SidebarNavBtn instance
 *
 * Locate the SidebarNav NODE and initialize it as well as any other
 * dom elements impacted through activation of the sidebar.
 *
 */
SidebarNavBtn.prototype.init = function () {
  const sidebarNavNode = document.getElementById("nav-side-bar-desktop");
  const pageContent = document.getElementById("page-content");
  const footer = document.getElementById("shopify-section-footer");
  const background = document.getElementById("nav-background-screen");

  if (sidebarNavNode) {
    const sidebarNav = new SidebarNav(sidebarNavNode, this);
    this.sidebarNav = sidebarNav;
    this.pageContent = pageContent;
    this.footer = footer;
    this.background = background;

    this.domNode.addEventListener("click", this.handleOpenSidebar.bind(this));
    this.background.addEventListener(
      "click",
      this.handleCloseSidebar.bind(this)
    );

    sidebarNav.init();
  }
};

SidebarNavBtn.prototype.activateOverlay = function () {
  this.pageContent.classList.add("frozen");
  this.background.classList.add("active");
  this.footer.style.display = "none";
};

SidebarNavBtn.prototype.deactivateOverlay = function () {
  this.pageContent.classList.remove("frozen");
  this.background.classList.remove("active");
  this.footer.style.display = "block";
};

SidebarNavBtn.prototype.handleCloseSidebar = function (event) {
  this.sidebarNav.domNode.classList.remove("active");
  this.domNode.setAttribute("aria-expanded", false);
  this.deactivateOverlay();
};

SidebarNavBtn.prototype.handleOpenSidebar = function (event) {
  this.sidebarNav.setFocusToFirstItem();
  this.sidebarNav.domNode.classList.add("active");
  this.domNode.setAttribute("aria-expanded", true);
  this.activateOverlay();
};

window.addEventListener("load", function () {
  const sideBarNavBtn = new SidebarNavBtn(
    document.getElementById("side-menu-button-desktop")
  );

  sideBarNavBtn.init();
});
